module.exports = __webpack_public_path__ + "static/img/about_h5bg_03_zh.06ea9a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about_h5bg_03_zh.png
// module id = E3GW
// module chunks = 34